"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleDialogActionButton = exports.SimpleDialog = void 0;
var SimpleDialog_1 = require("./SimpleDialog");
Object.defineProperty(exports, "SimpleDialog", { enumerable: true, get: function () { return __importDefault(SimpleDialog_1).default; } });
var SimpleDialogActionButton_1 = require("./SimpleDialogActionButton");
Object.defineProperty(exports, "SimpleDialogActionButton", { enumerable: true, get: function () { return __importDefault(SimpleDialogActionButton_1).default; } });
//# sourceMappingURL=index.js.map